import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { ProductsPage } from "./pages/ProductsPage";
import { MealsPage } from "./pages/MealsPage";
import MealsInDayPage from "./pages/MealsInDayPage";
import { ShoppingListPage } from "./pages/ShoppingListPage";
import { QuickCalcPage } from "./pages/QuickCalcPage";
import { ShoppingListDetailsPage } from "./pages/ShoppingListDetailsPage";
import { Layout } from "./components/Layout";
import { authService } from "./services/authService";
import { ToastProvider } from "./contexts/ToastContext";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/"/>;
};

export const App = () => {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meals"
            element={
              <ProtectedRoute>
                <MealsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mealsinday"
            element={
              <ProtectedRoute>
                <MealsInDayPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calculator"
            element={
              <ProtectedRoute>
                <QuickCalcPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shopping-lists"
            element={
              <ProtectedRoute>
                <ShoppingListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shopping-lists/:id"
            element={
              <ProtectedRoute>
                <ShoppingListDetailsPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </ToastProvider>
  );
};
